import { Box } from "@mui/material";

import { AttainmentBar, ProductSplitBar } from "../bars";
import {
  EmptyPanelMessage,
  NestedPanel,
  SectionLabel,
  SectionTitleRow,
} from "../primitives";
import { BORDER, LEFT_PANEL_MIN_HEIGHT } from "../tokens";

export default function ReferralsQtdPanel({
  attainmentProducts,
  referralSplits,
  onExplore,
}) {
  return (
    <NestedPanel
      sx={{
        minHeight: LEFT_PANEL_MIN_HEIGHT,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <SectionTitleRow label="Referrals QTD" onExplore={onExplore} />
      {attainmentProducts.length > 0 ? (
        <>
          <SectionLabel>Progress to Goal</SectionLabel>
          {attainmentProducts.map((product, index) => (
            <AttainmentBar key={product.name || index} product={product} />
          ))}
        </>
      ) : (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <EmptyPanelMessage>No insights found.</EmptyPanelMessage>
        </Box>
      )}
      {referralSplits.length > 0 && (
        <Box sx={{ mt: 2, pt: 2, borderTop: `1px solid ${BORDER}` }}>
          {referralSplits.map((split) => (
            <ProductSplitBar key={split.label} split={split} />
          ))}
        </Box>
      )}
    </NestedPanel>
  );
}
